// extracted by mini-css-extract-plugin
module.exports = {"followMe":"kj","linkItem":"kk","linkItemWrap":"kl","title":"km","linkAppItemWrap":"kn","iconWrap":"ko","mfollowMe":"kp","miconWrap":"kq","followMe-dark":"kr","followMeDark":"kr"};